import { render } from "./ReportSidebar.vue?vue&type=template&id=94f5d1a0&scoped=true"
import script from "./ReportSidebar.vue?vue&type=script&lang=js"
export * from "./ReportSidebar.vue?vue&type=script&lang=js"

import "./ReportSidebar.vue?vue&type=style&index=0&id=94f5d1a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94f5d1a0"]])

export default __exports__